import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"
import env from "../../env"
import { getItemDetailUrl } from "../../util/UrlGenerator"

import {
    initializeBookmarkButton,
    initializeBookmarks,
} from "../bookmarks/actions"
import { fetchItemActions, show, hide } from "./slice"

import ContextMenu from "./components/ContextMenuModal"
import { IItemData, ISpinnerElement } from "./index"
import { IOldUIContext } from "../../global"

const applicationPath = env.applicationPath

interface OldUIInit {
    start: (element: HTMLElement | undefined | null) => void
    show: (item: IItemData, targetElement: ISpinnerElement) => void
    hide: () => void
}

const init = (store: AppStore, oldUIContext: IOldUIContext): OldUIInit => {
    let spinnerElement: ISpinnerElement | undefined = undefined
    const getSpinnerElement = (): ISpinnerElement | undefined => {
        return spinnerElement
    }

    return {
        start: (element: HTMLElement | undefined | null): void => {
            if (!element) {
                throw new Error("Element should have value")
            }

            const root = createRoot(element)
            root.render(
                <Provider store={store}>
                    <OldUIContext.Provider value={oldUIContext}>
                        <ContextMenu getSpinnerElement={getSpinnerElement} />
                    </OldUIContext.Provider>
                </Provider>,
            )
        },

        show: (
            item: IItemData,
            targetElement: ISpinnerElement,
            shouldSkipOldUIBehavior = false,
        ): void => {
            spinnerElement = targetElement
            const {
                itemBoxContextMenu: { item: oldItem },
                resourceHeader: {
                    resource: { workspaceId },
                },
            } = store.getState()

            const url = getItemDetailUrl(
                applicationPath,
                item.relativePath,
                item.id,
            )

            if (oldItem?.id !== item.id) {
                store.dispatch(initializeBookmarks())
                store.dispatch(
                    initializeBookmarkButton(
                        "ITEMBOX_BOOKMARK_BUTTON",
                        null,
                        "Item",
                        item.id,
                        workspaceId,
                        null,
                        url,
                    ),
                )
                // Initialize bookmarks first to not force user waiting bookmark button loading when the context menu is already shown
                store.dispatch(
                    fetchItemActions({
                        item: item,
                        targetElement: targetElement,
                        shouldSkipOldUIBehavior: shouldSkipOldUIBehavior,
                    }),
                )
            } else {
                store.dispatch(show(targetElement))
            }
        },

        hide: (): void => {
            store.dispatch(hide())
        },
    }
}

export default init
